import type { CompanyStatus } from './schemas.ts';

/**
 * Human-readable labels for each company status. Single source of truth shared
 * by the status badge, the admin filters and the admin-facing digest email, so
 * the three can never drift apart.
 *
 * This lives in @l2u/shared rather than @l2u/ui because apps/api needs it: the
 * weekly station digest (apps/api/src/lib/adminStationDigest.ts) must say
 * "Not Compliant" in the admin's vocabulary while querying `expired` in the
 * database's, and the API worker cannot import @l2u/ui (React would end up in
 * the Cloudflare Worker bundle). @l2u/ui re-exports this, so every existing
 * `@l2u/ui/lib/companyStatus.ts` import keeps working unchanged.
 *
 * `expired: 'Not Compliant'` is the entry that most surprises readers, and it
 * is deliberate: there is no `not_compliant` value in the company_status enum.
 * "Not Compliant" is what admins call a vendor who WAS compliant and lapsed.
 */
export const COMPANY_STATUS_LABELS: Record<CompanyStatus, string> = {
  invited: 'Invited',
  in_progress: 'In progress',
  review: 'Action required',
  changes: 'Vendor change requested',
  compliant: 'Compliant',
  expired: 'Not Compliant',
  deactivated: 'Deactivated',
};
